// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".org-single-section {\n  display: flex;\n  flex-direction: column;\n}\n\n.org-single-img {\n  display: block;\n  width: auto;\n  height: auto;\n  object-fit: contain;\n}\n\n.org-single-logo {\n  height: 100px;\n  width: 100px;\n}\n\n.org-single-logo-header {\n  height: 100px;\n  width: 400px;\n}\n\n.org-single-logo-header-container {\n  height: 100px;\n  width: 300px;\n}\n", ""]);
// Exports
module.exports = exports;
